<template>
    <div>
        <el-table v-if="!$isMobile() && displayData.length" :data="displayData" border  height="500" fit
            size="mini" :row-class-name="tableRowClassName">
            <el-table-column prop="numero_orden" label="Orden" width="80">
            </el-table-column>
            <el-table-column prop="nombre" label="Apellido y nombre" width="">
                <template slot-scope="scope">
                    <span style="text-transform:uppercase">
                        {{ scope.row.apellido }},
                        {{ scope.row.nombre }}
                        - CUIL {{ scope.row.cuil_ultimos_digitos }}
                    </span>
                    <!-- <span v-else style="text-transform:uppercase">
                        {{ scope.row.nombre }} | No autorizó la publicación de sus datos
                    </span> -->
                </template>
            </el-table-column>

            <el-table-column prop="created_at" label="Fecha" width="160" sortable>
                <template slot-scope="scope">
                    {{ scope.row.created_at | moment('DD/MM/YYYY HH:mm:ss:SSS') }}
                </template>
            </el-table-column>
            <el-table-column prop="estado_nombre" label="Estado" width="160" sortable>
                <template slot-scope="scope">
                    <span :class="getEstadoClass(scope.row.estado)">
                        {{ scope.row.estado_nombre }}
                    </span>
                </template>
            </el-table-column>
        </el-table>

        <div class="responsive-table" v-if="$isMobile() && displayData.length">
            <div v-for="(item) in displayData" :key="item.id" class="list-item">
                <div class="list-header">
                    <span class="orden">Orden de registro: <strong>{{ item.numero_orden }}</strong></span>
                    <span class="fecha">{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss:SSS') }}</span>
                </div>
                <div class="list-body">
                    <strong>{{ item.apellido }}, {{ item.nombre }} - CUIL: {{ item.cuil_ultimos_digitos }}</strong>
                    <div :class="getEstadoClass(item.estado)" class="estado">
                        Estado: {{ item.estado_nombre }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['capa'],
    computed: {
        // Prioriza 'inscripciones', pero usa 'preinscripciones' si no hay 'inscripciones'
        displayData() {
            if (this.capa.inscripciones && this.capa.inscripciones.length > 0) {
                return this.capa.inscripciones;
            } else if (this.capa.preinscripciones && this.capa.preinscripciones.length > 0) {
                return this.capa.preinscripciones;
            } else {
                return [];
            }
        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.numero_orden <= this.capa.com.cupo && row.estado === null ) {
               
                return 'success-row';
            }
            return '';
        }
    ,
        getEstadoClass(estado) {
            switch (estado) {
                case null:
                    return 'estado-morado';
                case 0:
                    return 'estado-amarillo';
                case 1:
                case 2:
                    return 'estado-rojo';
                case 3:
                    return 'estado-verde';
                case 4:
                    return 'estado-gris';
                case 5:
                    return 'estado-rosa';
                case 6:
                    return 'estado-gris-oscuro';
                default:
                    return '';
            }
        }
    }
}
</script>
<style>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb !important;
}
</style>
<style scoped>
/* Estilos para pantallas grandes (como tabla) */

/* Estilos para pantallas móviles (como lista) */
@media (max-width: 768px) {
    .responsive-table {
        display: block;
    }

    .list-item {
        display: block;
        margin-bottom: 0px;
        border: 1px solid #ccc;
        border-radius: 0px;
        padding: 10px;
    }

    .list-header {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 5px;
    }

    .list-body {
        display: block;
        font-size: 12px;
    }

    .orden {
        /* font-weight: bold; */
    }

    .fecha {
        text-align: right;
    }

    .cuil {
        margin-top: 5px;
        font-size: 12px;
    }
}
</style>
